<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 8 of 10</span>  
</div><div>&nbsp;</div>
<div class="text-center">
    <h3>{{eappRegConsts.PageHeader}}<p>Temporary Tax Registration Certificate</p>
    </h3>
</div>
<div>&nbsp;</div>
<ng-container class="mx-5" *ngIf="TRCTotalTaxDue > 0">
    <p>
        <strong>
            Your online payment of <span style="color:red">{{TRCTotalTaxDue | currency}}</span> is due.
            <br /><br />
            After printing the certificate and clicking the submit button, the electronic
            payment process will begin. If the process does not succeed, a bill generated
            by the computer system will be sent to your mailing address in the near future.
            Penalty and interest may be charged due to the delay, so please make every effort
            to provide a valid form of payment during this process.
            <br /><br />
            The third-party payment vendor will send you a payment receipt via email following
            a successful payment. The Office of Finance will send you an application receipt
            via email containing important next steps to follow.
            <br /><br />
            Print certificate below and post at all business locations.
            <br /><br />
        </strong>
    </p>
</ng-container>
<div class="card my-md-4 p-md-4 dottedBdr">
    <div class="card-body">
        <div class="text-center">
            <p class="boldlbl">THIS CERTIFICATE MUST BE POSTED AT PLACE OF BUSINESS</p>
            <p class="boldlbl">City of Los Angeles TEMPORARY Tax Registration Certificate</p>
        </div>
        <div class="row">
            <div class="col-md-6 text-left">
                <p class="boldlbl">BUSINESS TAX</p>
            </div>
            <div class="col-md-6 text-right">
            	<!-- //INC0780209 Changing the Date Pattern to use 'yyyy' to avoid year increment issues -->
                <p class="boldlbl">APPLICATION DATE: {{TRCAppForm.postMarkDt | date:'MM/dd/yyyy'}}</p>
            </div>
        </div>
        <ng-container *ngIf=" (!RevTypesList===undefined || (RevTypesList.length)); else noData">
        <div class="tablerow">
            <div class="col-md-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                        <tr>
                            
                            <th>TAX PERIOD</th>
                            <th>FUND CLASS</th>
                            <th>DESCRIPTION</th>
                            <th>TRANSACTION TYPE</th>
                            <th>ENTRY TYPE</th>
                            <th>BASIS FOR TAX</th>
                            <th>CREDIT AMOUNT</th>
                            <th>PRINCIPAL</th>
                            <th>INTEREST</th>
                            <th>PENALTY</th>
                            <th>ROW TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let rev of RevTypesList" >
                            
                            <td>{{rev.taxPeriod}}</td>
                            <td>{{rev.revenue_type}}</td>
                            <td>{{rev.description}}</td>
                            <td>{{rev.transactionType}}</td>
                            <td>{{rev.entryType}}</td>
                            <td>{{rev.measure}}</td>
                            <td *ngIf="rev.isCredit" style="color:red">{{rev.creditAmt}}</td>
                            <td *ngIf="!rev.isCredit">{{rev.creditAmt}}</td>
                            <td>{{rev.principal}}</td>
                            <td>{{rev.interest}}</td>
                            <td>{{rev.penalty}}</td>
                            <td>{{rev.rowTotal}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
         </ng-container>
                    <ng-template #noData> 
                    <div class="text-center">No Data Available</div></ng-template>
        <div class="row">
            <div class="col-md-6">
                <p class="boldlbl">{{TRCAppForm.busid_Legal_Nm}}</p>
            </div>
            <div class="col-md-12 text-md-right">
            	<p> <b>Total Dues: <span>{{TRCTotalTaxDue | currency}}</span></b> </p>
            </div>
            <div class="col-md-6 text-md-left">
                <!-- 	INC0754669 - Enhancement - PFA EappReg - Adding GGR -->
            	<p *ngIf="Ggr"><b>Global Gross Receipts: </b>{{Ggr}}</p>
            	<!-- //INC0780209 Changing the Date Pattern to use 'yyyy' to avoid year increment issues -->
            	<p><b>Expiration Date: </b>{{expDate  | date:'MM/dd/yyyy'}}</p>
            </div>
        </div>
        <div>
        	<p><b>Business Account Number: </b>{{TRCAppForm.registration_Number}}</p>
        	
        	<p><b>Started: </b>{{TRCAppForm.busact_Start_Dt}}</p>
        	
        	<p><b>Status: </b>Pending</p>
        	
        	<p><b>PostMark Date: </b>{{TRCAppForm.postMarkDt | date:"MM/dd/yyy"}}</p>
        	
            <p><b>Primary Business Address:</b></p>
            <p>{{TRCAppForm.ba1_Str_Nbr}} {{TRCAppForm.ba1_Str_Nbr_Frac}} {{TRCAppForm.ba1_Str_Nm}} {{sessionStorage.TRCqBAStreetType}}
                &nbsp;{{sessionStorage.TRCUnitTypeDesc}} {{ TRCAppForm.ba2_Unit_Nbr}}</p>
            <p>{{TRCAppForm.ba3_City}}, {{TRCAppForm.ba3_State}} {{TRCAppForm.ba3_ZipCd}}</p>
            <p><b>Mailing Address:</b></p>
            <p>{{maLine1}}</p>
            <p>{{TRCAppForm.ma3_City}}, {{TRCAppForm.ma3_State}} {{TRCAppForm.ma3_ZipCd}}</p>
            <p><b>Issued By:</b> OFFICE OF FINANCE REGISTRATION WEBSITE</p>
        </div>
        <div>
            <p class="boldlbl text-center"><u>PLEASE READ ALL INFORMATION CAREFULLY</u></p>
            <div style="font-size: 10px;">
                <p>Sections 21.08(b) / 21.7.6(4) Los Angeles Municipal Code</p>
                <p>"This business tax registration certificate (and/or) Transient Occupancy Registration Certificate
                    signifies that the person named on the face hereof has fulfilled the requirements of Article 1 of
                    Chapter II of the Los Angeles Municipal Code (and/or) the Uniform Transient Occupancy Tax Ordinance,
                    by registering with the Director of Finance for the purpose of paying business tax for the
                    classification of business for which this certificate is issued (and/or) collecting from transients
                    the Transient Occupancy Tax and remitting said tax to the Director of Finance. This certificate does
                    not authorize the person to conduct any unlawful business or to conduct any lawful business in an
                    illegal (or) unlawful manner or to conduct within the City of Los Angeles the business for which
                    this certificate has been issued, nor to operate a hotel, without strictly complying with all the
                    provisions of the ordinances of said City (or) all local applicable laws, including but not limited
                    to those requiring a permit from any board, commission, department or office of the City. <span
                        style="font-weight:bold">THIS BUSINESS TAX REGISTRATION CERTIFICATE (AND/OR) CERTIFICATE DOES
                        NOT CONSTITUTE A PERMIT.</span> Any failure to comply with the requirements of Article 1 of
                    Chapter II of the Los Angeles Municipal Code shall constitute grounds for suspension of this
                    certificate."</p>
                <hr>
                <p>This certificate is void upon any change of ownership or location. Annual taxes are due and payable
                    January 1st each year and delinquent if not paid on or before the last day of February each year.
                    Quarterly taxes are due and payable on the first day of January, April, July, and October of each
                    year, and delinquent if not paid on or before the last day of the month due.</p>

            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <hr>
            </div>
            <div class="col-md-4">
                <p class="text-center">STATE BOARD OF EQUALIZATION NOTICE</p>
            </div>
            <div class="col-md-4">
                <hr>
            </div>
        </div>
        <p style="font-size: 10px;">Sales or use tax may apply to your business activities. You may seek written advice
            regarding the application of tax to your particular business by writing to the nearest State Board of
            Equalization office.</p>
            <br>
            <p style="font-size: 10px;"> If everything looks fine please submit your application form  to complete the registration.</p>
    </div>
</div>
<div class="row">
    <div class="col-md-12 text-center">
        <button class="btn btn-primary my-2" (click)="print()">Print</button>&nbsp;&nbsp;
        <button class="btn btn-primary my-2" (click)="submit()">Submit</button>
    </div>
</div>

<jhi-eappreg-confirm-text style="display: none;"  id="sendmail"></jhi-eappreg-confirm-text> 